import { Store, waitFor } from 'utils';
import { Creators } from 'model'
import lunr from 'lunr';

class StandStore extends Store {

	getInitialState() {
		return {
			stands: null,
			activeStands: null,
			ready: false,
			loading: false,
			map: null,
			sm: null,
			background: null,
			index: null,
			query: '',
			filters: {
				activities: [],
				companies: []
			}
		}
	}

	getQuery() {
		return this.getState().query;
	}

	getStands() {
		return this.getState().stands;
	}

	getActiveStands() {
		var state = this.getState();

		if (!this.isFiltered())
		{
			return this.getState().stands;
		}
		else
		{
			return this.getState().activeStands;
		}
	}
	
	getBackground() {
		return this.getState().background;
	}

	getFilters() {
		return this.getState().filters;
	}

	onPavilionsChanged(state, data) {
		state.background = data.backgroundURL;
	}

	onActiveStandsChanged(state, data) {
		state.activeStands = data.activeStands;
	}

	onStandSearchQueryChanged(state, data) {
		state.query = data.query;
		console.log('ovo je data', data);
	}

	onStandsLoading(state) {
		state.stands = null;
		state.ready = true;
		state.loading = true;
	}

	onStandsChanged(state, data)
	{
		state.stands = data.stands;
		state.loading = false;

		let map = [];
		let sm = [];

		data.stands.forEach((item) => {
			map[item.slug] = item.id;
			sm[item.slug] = item;
		});

		state.map = map;
		state.sm = sm;

		state.index = lunr(function () {

			this.field('pavilion');
			this.field('company');
			this.field('location');

			this.pipeline.remove(lunr.stemmer);

			data.stands.forEach((item) => {
				let pavilionsNames = item.pavilions.map((pavilion) => pavilion.name).join(' ');
				this.add({
					id: item.slug,
					pavilion: pavilionsNames,
					company: [item.companyName],
					location: [item.location]
				})
			})
		});
	}

	onStandsFiltersChanged(state, data)
	{
		state.filters[data.filterName] = data.filters;
	}

	filter(query, filters)
	{
		let state = this.getState();
		let tokens = query.split(/\s+/);

		let cleaner = /(\/ž\)$)|(\.$)|(\))/g;
		let sr = state.index.query((q) => {
			tokens.forEach((token) => {
				if (!token)
				{
					return;
				}

				let term = token.replace(cleaner, '').toLowerCase();
				let replacer = /(^([šžčćđ]))/gi;
				term = term.replace(replacer, '').toLowerCase();
				term = '*' + term + '*';
				q.term(term, {
					presence: lunr.Query.presence.REQUIRED
				});
				console.log('added term', term);
			});
		});

		return sr.map((item) => {
			return state.sm[item.ref];
		});
	}

	isFiltered()
	{
		var state = this.getState();

		if (state.query !== '')
		{
			return true;
		}

		const filters = state.filters;

		// This block will return bool 'true' if there is an active filter
		let hasActiveIndex = false;
		let filterKeys = Object.keys(filters);
		filterKeys.forEach((filterKey)=>
		{
			let activeIndex = filters[filterKey].findIndex((item, i) =>
			{
				return item.active;
			});
			if (activeIndex !== -1)
			{
				hasActiveIndex = true;
				return true;
			}
		});
		return hasActiveIndex;
	}

	findStandId(slug) {
		return this.getState().map[slug];
	}

	isReady() {
		return this.getState().ready == true;
	}

	isLoading()
	{
		return this.getState().loading;
	}

}

const store = new StandStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/standstore.js